import useTestBanner from "./useTestBanner";

const TestBanner = () => {
  const { testDetails, nextBtnHandler } = useTestBanner();

  return (
    <div className="p-10 my-10 flex flex-col gap-5 border border-gray-300 rounded-lg shadow-md">
      <span className="text-xl font-bold text-blue-900">
        {testDetails?.CourseTitle}
      </span>

      {testDetails?.ImgBanner && (
        <img src={testDetails.ImgBanner} alt="banner" className="rounded-lg" />
      )}

      <div className="flex flex-col gap-5">
        <span className="text-lg font-semibold text-gray-800">
          {testDetails?.TestTitle}
        </span>

        <span className="text-gray-600">{testDetails?.TestDesc}</span>

        <div className="flex justify-center items-center">
          <button
            onClick={nextBtnHandler}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestBanner;
